import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { handleCreateCompany } from "../../../api/companies";
import { useState } from "react";
import getBase64 from "../../../utils/getBase64";
import { CheckCircleFilled, DeleteOutlined } from "@ant-design/icons";

export default function CreateCompany({ isVisible, setVisible }: any) {
  const queryClient = useQueryClient();
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState(null);
  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const { mutate, isPending } = useMutation({
    mutationFn: handleCreateCompany,
    onSuccess: () => {
      message.success("Created Successfully");
      clearImage();
      queryClient.invalidateQueries({ queryKey: ["companies"] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const values = await form.getFieldsValue();

    let base64,
      type,
      size = null;

    if (selectedFile) {
      base64 = await getBase64(selectedFile);
      type = selectedFile?.type?.slice(selectedFile?.type - 3);
      size = selectedFile?.size;
    }

    const data = {
      ...values,
      logo: base64,
    };

    await mutate(data);
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
    form.setFieldsValue({ file: null });
    setSelectedFile(null);
    setIsSelected(false);
  };
  const clearImage = async () => {
    form.resetFields();
    form.setFieldsValue({ file: null });
    setSelectedFile(null);
    setIsSelected(false);
  };

  return (
    <Modal
      open={isVisible}
      title="New Company"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createCompany"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          {isPending ? "Submiting..." : "Submit"}
        </Button>,
      ]}
    >
      <Form
        id="createCompany"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="code"
              label="Company Number"
              rules={[
                {
                  required: true,
                  message: "Please enter company number",
                },
              ]}
            >
              <Input type="number" min={1} step={1} placeholder="e.g 1" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Company Name"
              rules={[
                {
                  required: true,
                  message: "Please enter company name",
                },
              ]}
            >
              <Input type="text" placeholder="e.g Toyota Tanzania Ltd" />
            </Form.Item>
          </Col>
        </Row>

        <div className="flex flex-col justify-center items-center bg-gray-100 h-32 rounded-md border">
          <div className="flex flex-col justify-center items-center">
            {isSelected ? (
              <div className="flex flex-col justify-center items-center">
                <CheckCircleFilled color={"#16a34a"} size={30} />
                <div className="text-gray-600 mt-2">Image Selected</div>
                <div className="text-gray-500">{selectedFile?.name}</div>
                <button
                  className="text-red-200 flex items-center hover:text-red-500"
                  onClick={() => clearImage()}
                >
                  <DeleteOutlined /> <span className="mx-1">Remove</span>
                </button>
              </div>
            ) : (
              <Form.Item
                name="file"
                label="Upload Logo ( Optional )"
                rules={[
                  {
                    required: false,
                    message: "Please select file",
                  },
                ]}
              >
                <Input
                  type="file"
                  placeholder="Image"
                  onChange={changeHandler}
                />
              </Form.Item>
            )}
          </div>
        </div>
      </Form>
    </Modal>
  );
}
